import { ComponentStyleConfig } from '@chakra-ui/react';

const Button: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 16,
    fontWeight: 600,
    transition: 'all 0.2s ease',
  },
  sizes: {
    '2xl': {
      fontSize: 24,
    },
    xl: {
      fontSize: 18,
    },
    lg: {
      fontSize: 16,
    },
    md: {
      fontSize: 14,
    },
    sm: {
      fontSize: 12,
    },
    xs: {
      fontSize: 10,
    },
  },
  variants: {
    primary: {
      color: 'white',
      bg: 'blackAlpha.900',
      border: '1px solid transparent',
      _hover: {
        bg: 'white',
        color: 'black',
        borderColor: 'black',
      },
      _active: {
        bg: 'blackAlpha.100',
        color: 'black',
        borderColor: 'black',
      },
      _disabled: {
        _hover: {
          bg: "blackAlpha.900 !important",
          color: 'white !important',
          borderColor: 'transparent !important',
        },
      },
    },
    secondary: {
      bg: 'white',
      color: 'black',
      border: '1px solid black',
      _hover: {
        bg: 'blackAlpha.100',
        transform: 'translateY(-1px)',
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.10)',
      },
      _active: {
        transform: 'translateY(0)',
        boxShadow: 'none',
      },
    },
    ghost: {
      bg: 'primary',
      color: 'black',
      borderRadius: 12,
      _hover: {
        bg: 'blackAlpha.200',
      },
      _disabled: {
        _hover: {
          bg: "black !important",
        },
      }
    },
  },
};

export default Button;
